import React, { Component } from 'react';
import { connect } from 'react-redux';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import DocumentItem from './DocumentItem';
import _ from 'underscore';
import DocumentDetails from './DocumentDetails';
import NoData from '../page/NoData';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const FORM_NAME = 'PROCESSED_DOCUMENT_LIST_FORM';
const log = new Logger('PROCESSED_DOCUMENT_LIST_FORM', LOG_LEVELS.DEBUG);

class DocumentListForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      documentDetailsOpen: false
    };
  }

  onSelectAll(select) {
    const documentList = this.props.documentList;
    log.debug('onSelectAll(): ', select, documentList);
    if (!documentList) {
      return;
    }
    const fieldValues = documentList.reduce((values, document) => {
      if (document.id === null) {
        return values;
      }
      values[document.id + ''] = select;
      return values;
    }, { '_all': select });
    this.props.doInitialiseForm(fieldValues);
  }

  onSelectDocumentFactory(documentId) {
    return (select) => {
      log.debug('onSelectDocumentFactory(%s): ', documentId, select);
      this.props.onFieldChange(documentId + '', select);
    };
  }

  onSelectDocumentDetailFactory(documentId) {
    return (event) => {
      log.debug('onSelectDocumentDetailFactory(%s): ', documentId);
      this.props.loadDocumentDetails(documentId);
      this.setState({
        documentDetailsOpen: true
      });
    };
  }

  onCloseDocumentDetails() {
    log.debug('onCloseDocumentDetails: ');
    this.props.UnloadDocumentDetails();
    this.setState({
      documentDetailsOpen: false
    });
  }

  onRequestActionFactory(action) {
    return (evt) => {
      log.clearAllDictionaryErrors();
      const documentList = this.props.documentList;
      const fieldValues = this.props.formData && this.props.formData.fieldValues;
      log.debug('onRequestActionFactory(%s): ', action, documentList, fieldValues);

      const documentIdsToAction = this.getSelectedIds();
      log.debug('onRequestActionFactory(%s): documentIdsToAction: ', action, documentIdsToAction);
      this.props.onRequestAction(action, documentIdsToAction);
      this.props.doFormSubmitted();
    }

  }

  getSelectedIds() {
    const documentList = this.props.documentList;
    const fieldValues = this.props.formData && this.props.formData.fieldValues;

    const documentIdsToAction = _.reduce(documentList, (list, value, id) => {
      if (fieldValues[value.id + '']) list.push({ id: value.id, fileName: value.fileName });
      return list;
    }, []);
    return documentIdsToAction;
  }

  render() {
    log.debug('render(): ', this.props);
    const documentList = this.props.documentList;
    const fieldValues = this.props.formData && this.props.formData.fieldValues;
    const selectedCount = (fieldValues && this.getSelectedIds().length) || 0;
    return (
      <ReadOnlyWrapper>
        <div>
          {
            (() => {
              if (!documentList || documentList.length <= 0) {
                return (
                  <NoData
                    noDataText="processedDocuments_NoData"
                  />
                );
              }

              if (!documentList || documentList.length > 0) {
                return (
                  <div>
                    <table className="word-break-all">
                      <thead>
                        <DocumentItem
                          header={true}
                          formInitialising={!fieldValues}
                          onSelect={this.onSelectAll.bind(this)}
                          selected={fieldValues && fieldValues['_all']}
                        />
                      </thead>
                      <tbody>
                        {
                          (() => {
                            return documentList.map((document, index) => {
                              if (document.id === null) {
                                return (
                                  <DocumentItem
                                    key={index}
                                    formInitialising={!fieldValues}
                                    document={document}
                                  />
                                );
                              }
                              return (
                                <DocumentItem
                                  key={index}
                                  formInitialising={!fieldValues}
                                  document={document}
                                  onSelect={this.onSelectDocumentFactory(document.id).bind(this)}
                                  selected={fieldValues && fieldValues[document.id + '']}
                                  loadDocumentDetails={this.onSelectDocumentDetailFactory(document.id).bind(this)}
                                />
                              );
                            })
                          })()
                        }
                      </tbody>
                    </table>
                    <div>
                      <button
                        disabled={selectedCount === 0 ? 'disabled' : ''}
                        className={'secondary mt20'}
                        onClick={this.onRequestActionFactory('export').bind(this)}
                        excludeFromReadonly={true}
                      >
                        <LanguageStringResolver string="documentDetails_exportSelectedDocuments" />
                      </button>
                      <button
                        disabled={selectedCount === 0 ? 'disabled' : ''}
                        className={'secondary mt20'}
                        onClick={this.onRequestActionFactory('delete').bind(this)}
                      >
                        <LanguageStringResolver string="documentDetails_deleteSelectedDocuments" />
                      </button>
                      <button
                        disabled={selectedCount === 0 ? 'disabled' : ''}
                        className={'secondary mt20'}
                        onClick={this.onRequestActionFactory('redeliver').bind(this)}
                      >
                        <LanguageStringResolver string="documentDetails_redeliverSelectedDocuments" />
                      </button>
                    </div>
                    <hr />
                    <div>
                      <DocumentDetails
                        documentDetails={this.props.documentDetails}
                        onClose={this.onCloseDocumentDetails.bind(this)}
                        open={this.state.documentDetailsOpen} />
                    </div>
                  </div>
                );
              }
            })()
          }
        </div>
      </ReadOnlyWrapper>
    );
  }
  componentWillUnmount() {
    log.debug('componentWillMount(): ', this.props);
    this.props.doDestroyForm();
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.onSelectAll(this.props.initialSelection);
  }
}


function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & props', state, props);
  return {
    formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME]),
    languages: state.languages,
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    doInitialiseForm: (initialValues) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, initialValues));
    },
    doResetForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
    },
    doClearForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
    },
    onFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
    },
    doFormSubmitted: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
    },
    doDestroyForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(FORM_NAME));
    }
  }
}
export default connect(mapStateToProps, mapDispatchersToProps)(DocumentListForm);